var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-result__inner"},[_c('div',{staticClass:"search-result__main"},[_c('h1',[_vm._v(_vm._s(_vm.firstTitlePart))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.getFieldValue(_vm.result.Fields, 'Description', 'Unknown', true))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }